import React from 'react'
import Navbar from '../Components/Navbars/Navbar'

const ResumePage = () => {
    return (
        <div>
            <Navbar />

            ResumePage
        </div>
    )
}

export default ResumePage